var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicenseHolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9862 7.0005C7.88152 7.0005 9.41997 5.43306 9.41997 3.49975C9.41997 1.56644 7.88152 0 5.9862 0C4.08988 0 2.55243 1.56644 2.55243 3.49975C2.55243 5.43306 4.08888 7.0005 5.9862 7.0005ZM10.7165 9.18472C9.93179 8.27105 9.66688 7.95616 8.2304 7.87219H3.747C2.30951 7.95816 2.04561 8.27105 1.26289 9.18472C0.429185 10.1274 -0.234578 11.325 0.0793096 12.8064C0.429185 13.7771 1.37085 14 2.26453 14H9.71587C10.6085 14 11.5522 13.7751 11.9021 12.8064C12.213 11.325 11.5502 10.1284 10.7165 9.18472Z",
    fill: "#5C88FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseHolderIcon);
export default __webpack_public_path__ + "static/media/license_holder_icon.2e41444fdd9dd1e581cc8d097b4232dd.svg";
export { ForwardRef as ReactComponent };